import { Card, FooterMenu, Loading, SummaryBox } from "components"
import moment from "moment"
import { Fragment, useEffect, useState } from "react"
import { SelectedState } from "../../types/AgedPayable"
import { TableSection } from "./components"
import { exportExcel } from "./functions"
import { calculateSummary } from "./functions/calculateSummary"
import { useList } from "./hooks"
import { useExportPdf } from "./hooks/useExportPdf"
import { SearchingSections } from "./SearchingSection"
import { Summary } from "./types"

export function RegisterAgedPayable() {
  // Hooks
  const [selected, setSelected] = useState<SelectedState>({ date_from: "", date_end: "", vendor_id: "", bill_status: "1" })
  const { data, isLoading, refetch } = useList()
  const exportDateFormat = `${moment(selected.date_from).format("DD/MM/YYYY")} - ${moment(selected.date_end).format("DD/MM/YYYY")}`
  const exportPdf = useExportPdf({
    data: data,
    dateFilter: exportDateFormat
  })

  // Vars
  const summary: Summary = calculateSummary(data)

  useEffect(() => {
    const filteredSelected: Partial<SelectedState> = {};

    (Object.keys(selected) as Array<keyof SelectedState>).forEach(key => {
      if (selected[key]) { filteredSelected[key] = selected[key] }
    });

    refetch(filteredSelected);

    // eslint-disable-next-line
  }, [selected])

  return (
    <Fragment>
      <section className="mt-2">
        <Card>
          <Card.Body>
            <SearchingSections
              selected={selected}
              setSelected={setSelected}
            />
          </Card.Body>
        </Card>
      </section>

      {isLoading
        ? <Card className="mt-2"><Card.Body><div className="flex justify-center py-12"><Loading loading /></div></Card.Body></Card>
        : <>
          <section className="mt-2">
            <Card>
              <Card.Body>
                <TableSection data={data} isLoading={isLoading} />
              </Card.Body>
            </Card>
          </section>

          <section className="mt-2">
            <FooterMenu
              export={{
                actiontype: "export", onClick: () => exportExcel({
                  data: data,
                  dateFilter: exportDateFormat
                })
              }}
              pdf={{ actiontype: "pdf", onClick: exportPdf.handleExportPdf }}
              customRightElement={(
                <section className="flex gap-3">
                  <SummaryBox
                    label="Total"
                    amount={summary.balance}
                  />

                  <SummaryBox
                    label="7 Days"
                    amount={summary["7_day"]}
                  />

                  <SummaryBox
                    label="15 Days"
                    amount={summary["15_day"]}
                  />

                  <SummaryBox
                    label="21 Days"
                    amount={summary["21_day"]}
                  />

                  <SummaryBox
                    label="30 Days"
                    amount={summary["30_day"]}
                  />

                  <SummaryBox
                    label="60+ Days"
                    amount={summary["60_day"]}
                  />
                </section>
              )}
            />
          </section>
        </>
      }
    </Fragment>
  )
}